module.exports = __webpack_public_path__ + "static/best2-1f1044f9588b2f9f9a4323361d960ce1.jpg";